<template>
  <div>
    <div class="anz-hidden-mo">
      <div class="anz-flex-sm anz-flex-wrap anz-fs-xxxs">
        <div class="anz-flex anz-align-items-center">
          <a-button
            className="anz-link anz-link-hover-underline anz-mb-xs-mo"
            :class="{
              'anz-link-underline anz-strong anz-link-inverse': isBest,
            }"
            :title="$translate('post.menu.best')"
            @click="emitBestStrategy()"
          />
          <span class="anz-mx-xs anz-small anz-hidden-mo">|</span>
        </div>
        <div class="anz-flex anz-align-items-center">
          <a-button
            className="anz-link anz-link-hover-underline anz-mb-xs-mo"
            :class="{
              'anz-link-underline anz-strong anz-link-inverse': isNewest,
            }"
            :title="$translate('post.menu.newest')"
            @click="emitNewestStrategy()"
          />
          <span class="anz-mx-xs anz-small anz-hidden-mo">|</span>
        </div>
        <div class="anz-flex anz-align-items-center">
          <a-button
            className="anz-link anz-link-hover-underline anz-mb-xs-mo"
            :class="{
              'anz-link-underline anz-strong anz-link-inverse': isOldest,
            }"
            :title="$translate('post.menu.oldest')"
            @click="emitOldestStrategy()"
          />
        </div>
      </div>
    </div>
    <select
      class="anz-fc-field anz-py-0 anz-pl-s anz-b-none anz-font-bold anz-fs-xxxs anz-align-right anz-hidden-sm"
      @change="onChange(selectMenuValue)"
      v-model="activePage"
      dir="rtl"
    >
      <option :value="BEST" @click="emitBestStrategy()">{{
        $translate('post.menu.best')
      }}</option>
      <option :value="NEWEST" @click="emitNewestStrategy()">{{
        $translate('post.menu.newest')
      }}</option>
      <option :value="OLDEST" @click="emitOldestStrategy()">{{
        $translate('post.menu.oldest')
      }}</option>
    </select>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue'
import useClickOutside from '@/composables/clickOutside/clickOutside'
import AButton from '@/components/Forms/AButton.vue'
import usePostListMenu, {
  ActivePostPage,
  usePostListMenuCache,
} from '@/composables/ui/postListMenu'
import useContextChangeVars from '@/composables/contextCahngeVars/contextChangeVars'
import { PostContentConstraints } from '@/validation/postValidator'

export default defineComponent({
  name: 'PostListMenu',
  emits: ['change-strategy'],
  components: { AButton },
  props: {
    currentStrategy: {
      type: Number,
    },
  },
  data() {
    return {
      selectMenuValue: null,
      NEWEST: ActivePostPage.Newest,
      OLDEST: ActivePostPage.Oldest,
      BEST: ActivePostPage.Best,
    }
  },
  methods: {},
  setup() {
    const menuRef: Ref<Node | undefined> = ref()
    const { windowActive, toggleWindow } = useClickOutside(menuRef)
    const { activePage } = usePostListMenu()
    const { updateDefaultPostListMenuCache } = usePostListMenuCache()
    const { contextChange } = useContextChangeVars()

    const emitNewestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Newest
      updateDefaultPostListMenuCache()
      contextChange()
    }
    const emitOldestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Oldest
      updateDefaultPostListMenuCache()
      contextChange()
    }
    const emitBestStrategy = () => {
      toggleWindow()
      activePage.value = ActivePostPage.Best
      updateDefaultPostListMenuCache()
      contextChange()
    }

    const onChange = (selectMenuValue: string | undefined) => {
      if (selectMenuValue === ActivePostPage.Newest) {
        emitNewestStrategy()
      } else if (selectMenuValue === ActivePostPage.Oldest) {
        emitOldestStrategy()
      } else if (selectMenuValue === ActivePostPage.Best) {
        emitBestStrategy()
      }
    }

    return {
      menuRef,
      windowActive,
      emitNewestStrategy,
      emitOldestStrategy,
      emitBestStrategy,
      toggleWindow,
      onChange,
      ...usePostListMenu(),
    }
  },
})
</script>
